module.exports = __webpack_public_path__ + "static/media/logoPesawat.010967da.svg";